import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

var _Icon, _Icon2;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useRef, useEffect, useCallback } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useQueryParam } from "../../../../../query";
import Icon from "../../../../Common/Icon";
import { Text } from "../../../../Typography";
import styles from './Search.scss';

var Search = function Search(_ref) {
  var _ref$isOpened = _ref.isOpened,
      isOpened = _ref$isOpened === void 0 ? false : _ref$isOpened,
      onSubmit = _ref.onSubmit,
      onClose = _ref.onClose;

  if (!isOpened) {
    return null;
  }

  var _useTranslation = useTranslation('headerUi'),
      t = _useTranslation.t;

  var _useQueryParam = useQueryParam('q'),
      _useQueryParam2 = _slicedToArray(_useQueryParam, 2),
      searchQuery = _useQueryParam2[0],
      setSearchQuery = _useQueryParam2[1];

  var _useState = useState(searchQuery || ''),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      onChange = _useState2[1];

  var inputRef = useRef(null);
  useEffect(function () {
    if (inputRef.current) inputRef.current.focus();
  }, [isOpened]);
  var handleBlur = useCallback(function () {
    if (!value) onClose();
  }, [value]);
  var handleSubmit = useCallback(function (e) {
    e.preventDefault();
    setSearchQuery(value);
    onSubmit(value);
  }, [value]);
  var handleClose = useCallback(function () {
    onSubmit('');
    onClose();
  }, []);
  var handleKeyDown = useCallback(function (e) {
    if (e.key === 'Escape') handleClose();
  }, []);
  var handleChange = useCallback(function (e) {
    onChange(e.currentTarget.value);
  }, []);
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit,
    className: styles.searchWrap
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.searchIconWrap
  }, _Icon || (_Icon = /*#__PURE__*/React.createElement(Icon, {
    color: "text",
    name: "search"
  }))), /*#__PURE__*/React.createElement("input", {
    value: value,
    placeholder: t('SEARCH_PLACEHOLDER'),
    ref: inputRef,
    className: styles.searchInput,
    type: "text",
    onKeyDown: handleKeyDown,
    onChange: handleChange,
    onBlur: handleBlur
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.searchHintWrap, _defineProperty({}, styles.isHidden, !value))
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: styles.searchHint
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, t('SEARCH_HINT')), /*#__PURE__*/React.createElement(Icon, {
    className: styles.searchHintIcon,
    color: "text",
    name: "enter",
    size: "medium"
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.searchCloseWrap
  }, /*#__PURE__*/React.createElement("button", {
    className: styles.searchCloseButton,
    type: "button",
    onClick: handleClose
  }, _Icon2 || (_Icon2 = /*#__PURE__*/React.createElement(Icon, {
    color: "text",
    name: "close",
    size: "medium"
  })))));
};

export default Search;